import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { LoaderCircle } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
  const { user, loading, isAdmin, siteSettings, siteSettingsLoading } = useAuth();
  const location = useLocation();

  // Site settings poll in the background. Keep the current route mounted once
  // settings exist so a refresh cannot wipe an in-progress test or form.
  if (loading || (siteSettingsLoading && !siteSettings)) {
    return (
      <div className="min-h-screen bg-[#07101f] text-white flex items-center justify-center">
        <LoaderCircle className="h-6 w-6 animate-spin" aria-hidden="true" />
        <span className="sr-only">Loading account</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/auth" state={{ from: location }} replace />;
  }

  if (siteSettings?.site_locked && !isAdmin) {
    return (
      <div className="site-page flex min-h-screen items-center justify-center text-white">
        <div className="site-panel w-full max-w-3xl overflow-hidden">
          <div className="site-panel__header"><span>Site temporarily locked</span><span className="text-[#f4c86d]">● Maintenance</span></div>
          <div className="p-6 text-sm leading-relaxed text-[#b9cbdd]">
            CBAT Academy is currently restricted while platform updates are in progress. Administrator access remains available.
          </div>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
